import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  font-family: 'Roboto', sans-serif;
  font-size: 30px;
  height: 47px;
  position: relative;
`;
Container.displayName = 'Container';

export const DecoratorLeft = styled.div`
  background: rgb(156, 14, 30);
  background: linear-gradient(
    5deg,
    rgba(156, 14, 30, 1) 0%,
    rgba(54, 3, 8, 0) 46%
  );
  height: 56px;
  position: absolute;
  width: 300px;
  z-index: 15;
`;
DecoratorLeft.displayName = 'DecoratorLeft';

export const DecoratorRight = styled.div`
  background: rgb(156, 14, 30);
  background: linear-gradient(
    -5deg,
    rgba(156, 14, 30, 1) 0%,
    rgba(54, 3, 8, 0) 38%
  );
  height: 56px;
  position: absolute;
  right: 0;
  width: 255px;
  z-index: 15;
`;
DecoratorRight.displayName = 'DecoratorRight';

export const Logo = styled.img`
  position: relative;
  top: -2px;
`;
Logo.displayName = 'Logo';

export const Points = styled.div`
  line-height: 56px;
  min-width: 50px;
`;
Points.displayName = 'Points';

export const PointsContainer = styled.div`
  align-items: center;
  background: rgb(128, 45, 49);
  background: linear-gradient(
    180deg,
    rgba(128, 45, 49, 1) 30%,
    rgba(54, 3, 8, 1) 100%
  );
  color: #cfb99b;
  display: flex;
  font-size: 36px;
  font-weight: bold;
  justify-content: center;
  min-width: 110px;
  text-align: center;
`;
PointsContainer.displayName = 'PointsContainer';

export const TeamContainer = styled.div`
  background: rgb(23, 20, 17);
  background: linear-gradient(
    0deg,
    rgba(23, 20, 17, 1) 50%,
    rgba(46, 42, 40, 1) 50%
  );
  display: flex;
  height: 56px;
  overflow: hidden;
  z-index: 1;
`;
TeamContainer.displayName = 'TeamContainer';

export const TeamName = styled.div`
  color: #a18968;
  font-size: 33px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0.1em;
  line-height: 56px;
  min-width: 150px;
  padding: 0 12px;
  position: relative;
  text-align: ${({ textAlign }) => textAlign};
`;
TeamName.displayName = 'TeamName';

export const TimerContainer = styled.div`
  align-items: center;
  background: rgb(23, 20, 17);
  background: linear-gradient(
    0deg,
    rgba(23, 20, 17, 1) 50%,
    rgba(46, 42, 40, 1) 50%
  );
  display: flex;
  height: 56px;
  justify-content: center;
  min-width: 220px;

  &:after {
    background: #cfb99b;
    content: '';
    height: 22px;
    left: 18px;
    position: relative;
    width: 2px;
    z-index: 9;
  }
`;
TimerContainer.displayName = 'TimerContainer';

export const Timer = styled.div`
  color: #cfc6ab;
  font-size: 42px;
  font-style: normal;
  font-weight: normal;
  letter-spacing: 0.03em;
  line-height: 56px;
  margin-left: 24px;
  text-align: center;
`;
Timer.displayName = 'Timer';
